import '../../../../../../components/accordion.js.es6';

function trackFaqEvent(eventData) {
  App.track.event('room_page_interaction', {
    section: 'room_faq',
    ...eventData,
  });
}

export const initFaq = () => {
  const section = document.querySelector('.js-room-faq');
  if (!section) return;

  const sectionObserver = new IntersectionObserver((entries) => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    trackFaqEvent({ element: 'question', interaction: 'visible' });
    sectionObserver.disconnect();
  }, { threshold: 0.2 });
  sectionObserver.observe(section);

  section.querySelectorAll('.ds-accordion__trigger').forEach((trigger, index) => {
    trigger.addEventListener('click', () => {
      // the shared accordion component has already toggled the state by the time this handler runs
      const isExpanded = trigger.parentElement.classList.contains('ds-accordion--open');
      trackFaqEvent({
        element: 'question',
        element_value: index + 1,
        interaction: isExpanded ? 'unfold' : 'fold',
      });
    });
  });
};
